
export const DEFUALT_FETCH_LIST_REQUEST = {
  pageNumber: 0,
  pageSize: 10,
  sortField: 'createdAt',
  sortDirection: 'desc',
  caseType: "DOMESTIC"
}

export const DEFUALT_INTERNATIONAL_FETCH_LIST_REQUEST = {
  pageNumber: 0,
  pageSize: 10,
  sortField: 'createdAt',
  sortDirection: 'desc',
  caseType: "INTERNATIONAL"
}
export const BULK_CASE = "Bulk Case";
export const BULK_QUICK_CASE = "Bulk Quick Case";
export const BULK_INTERNATIONAL_CASE = "Bulk International Case";
export const DEFAULT_CASE_TYPE_LIST = [BULK_CASE, BULK_QUICK_CASE,BULK_INTERNATIONAL_CASE]